import React from 'react';
import {
  Grid,
  makeStyles,
  createStyles,
  Theme,
  Typography,
  ButtonBase,
} from '@material-ui/core';
import { colors, DefaultButton } from 'design-system';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorContainer: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      marginTop: 10,
    },
    errorCircle: {
      display: 'inline-block',
      width: 170,
      height: 170,
      borderRadius: 85,
      backgroundColor: '#F5F5F5',
    },
    errorCircleContent: {
      height: '100%',
    },
    errorImage: {
      marginTop: 10,
      marginBottom: 20,
    },
    fontCaption: {
      fontSize: 15,
      lineHeight: '22px',
    },
    fontTitle: {
      fontSize: 19,
      lineHeight: '24px',
      fontWeight: 900,
    },
    fontSubtitle: {
      marginTop: 20,
      fontSize: 15,
      lineHeight: '22px',
      fontWeight: 400,
      color: colors.abbey,
    },
  }),
);

const EmailErrorLayout = (): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.errorContainer}>
      <Grid container justifyContent="center" spacing={3}>
        <Grid item xs={12} sm={6} md={4} container justifyContent="center">
          <Typography variant="h2" align="center" className={classes.fontTitle}>
            Lo sentimos, parece que tu correo electrónico no coincide.
          </Typography>

          <Typography
            variant="body2"
            align="center"
            className={classes.fontSubtitle}
          >
            Revisa el correo y asegúrate de que sea correcto para continuar con
            la firma.
          </Typography>
        </Grid>
        <Grid item xs={12} container justifyContent="center">
          <img
            className={classes.errorImage}
            data-testid="error-image"
            alt="error"
            src="/images/error_image.svg"
          />
        </Grid>
        <Grid item xs={12} container justifyContent="center">
          <Grid item xs={12} sm={6} md={3}>
            <DefaultButton fullWidth>Revisar correo electrónico</DefaultButton>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4} container justifyContent="center">
          <Typography
            variant="caption"
            align="center"
            className={classes.fontCaption}
          >
            <div>
              Si el error persiste, escríbenos al{' '}
              <ButtonBase
                onClick={(): Window | null =>
                  window.open(`https://wa.me/50625032772`)
                }
                id="sales-web-inspection-whatsapp-button-text"
                data-testid="whatsapp-button-text"
                style={{
                  color: colors.bright_turquoise,
                  fontWeight: 700,
                  verticalAlign: 'bottom',
                }}
                component="span"
              >
                WhatsApp
              </ButtonBase>{' '}
              <ButtonBase
                onClick={(): Window | null =>
                  window.open(`https://wa.me/50625032772`)
                }
                id="sales-web-inspection-whatsapp-button-number"
                data-testid="whatsapp-button-number"
                style={{
                  color: colors.bright_turquoise,
                  fontWeight: 700,
                  verticalAlign: 'bottom',
                }}
                component="span"
              >
                (506)2503-2772
              </ButtonBase>{' '}
              o a soporte técnico:
              <div>
                <a
                  data-testid="anchor-email"
                  href="mailto:soporteventasautocr@assanet.com"
                  className={classes.fontSubtitle}
                >
                  soporteventasautocr@assanet.com
                </a>
              </div>
            </div>
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default EmailErrorLayout;
